import { ResponseBase } from '../response-base.model';
import { TipoEncuesta } from '../tipo-encuesta.model';
import { EncuestasInterna } from './encuestas-interna.model';
export class ListadoEncuestaInterna extends ResponseBase {
    encuestaInterna: EncuestasInterna[] = [];
    tipoEncuesta : TipoEncuesta[] =[]
}
